<template>
  <div class="d-flex">
    <v-text-field
      style="max-width: 140px"
      autocomplete="off"
      class="mr-2"
      reverse
      @blur="emitAmountValue()"
      v-model="amountValue"
      :label="label"
      :prepend-icon="icon"
      maxlength="19"
    ></v-text-field>
    <v-select
      style="max-width: 65px"
      class="text-md-body-1 text-caption"
      v-model="currency"
      return-object
      :items="currencies"
      item-text="symbol"
      :disabled="currencyDisabled || isSingleCurrency"
      @input="emitAmountValue()"
      label="Cur."
    ></v-select>
  </div>
</template>

<script>
import { Amount } from "@/model";
const amountRegex = /(?<number>-?\d+(\s*\d+)*(\.\d{0,2})?)/;

export default {
  props: {
    label: {
      type: String,
      default: "Amount",
    },
    currencyDisabled: {
      type: Boolean,
      default: true,
    },
    amount: {
      type: Object,
      default: () => undefined,
    },
    digitSeperator: {
      type: String,
      default: " "
    },
    icon: {
      type: String,
      default: ""
    }
  },
  created() {
    this.currency = this.$store.state.primaryCurrency;
    this.onAmount(this.amount);
  },
  data: () => ({
    amountValue: "",
    currency: undefined,
    numberOfDecimals: 2,
  }),
  computed: {
    currencies() {
      return this.getCurrencies();
    },
    currencySymbol() {
      window.currency = this.currency;
      return this.currency ? this.currency.symbol : "N/A";
    },
    isSingleCurrency() {
      return !this.$store.state.configurations.isMultiCurrencyActive();
    },
  },
  watch: {
    amount() {
      this.onAmount(this.amount);
    }
  },
  methods: {
    onAmount(amount) {
      if (amount) {
        this.currency = amount.currency.obj();
        this.amountValue = this.parseValue(amount.value.toString());
        return;
      }
      else {
        this.amountValue = 0;
      }
    },
    getCurrencies() {
      if (!this.isSingleCurrency) {
        return [...this.$store.state.currencies];
      }
      else {
        this.currency = this.$store.state.primaryCurrency;
        return [this.$store.state.primaryCurrency];
      }
    },
    seperator(amountValue, n, digitSeperator) {
      const splits = amountValue.split(".");
      const beforeDecimals = splits[0].split("").reverse();
      let seperated = "";
      for (let i = 0; i < beforeDecimals.length; i++) {
        seperated = beforeDecimals[i] + seperated;
        if ((i + 1) % n === 0) {
          seperated = digitSeperator + seperated;
        }
      }
      const suffix = splits.length === 0 ? "" : (splits[1] ? ("." + splits[1]) : "");
      return seperated.trim() + suffix;
    },
    parseValue(amount) {
      const parsed = amountRegex.exec(amount.toString().trim());
      if (!parsed) {
        return "";
      }
      const unpadded = parsed.groups["number"].replaceAll(" ", "");
      const index = unpadded.indexOf(".");
      let padded;
      if (index === -1) {
        padded = unpadded + ".00";
      } else {
        padded = unpadded.padEnd(index + 3, "0");
      }
      return this.seperator(padded, 3, this.digitSeperator);
    },
    emitAmountValue() {
      if (this.amountValue === "") {
        this.amountValue = "0";
      }
      else {
        this.amountValue = this.parseValue(this.amountValue);
      }
      let value = parseFloat(this.amountValue.replaceAll(" ", ""));
      if (isNaN(value)) {
        this.amountValue = "0";
        value = 0;
      }
      const amount = new Amount(value, this.currency.getRef());
      this.$emit("update:amount", amount);
      this.$emit("onAmount", amount);
    },
  },
};
</script>